mutation EndPracticeSession {
  endPracticeSession {
    ok
  }
}
